var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.667 2c5.522 0 10 4.477 10 10s-4.478 10-10 10-10-4.477-10-10 4.477-10 10-10m4.53 5.47a.75.75 0 0 0-1.06 0l-3.47 3.47-3.47-3.47a.75.75 0 1 0-1.06 1.06l3.47 3.47-3.47 3.47a.75.75 0 1 0 1.06 1.06l3.47-3.47 3.47 3.47a.75.75 0 1 0 1.06-1.06L13.727 12l3.47-3.47a.75.75 0 0 0 0-1.06"
  })));
};
export default SvgCloseCircle;